import "jquery-validation";

(function ($, window) {
  var DelhiZoo = window.DelhiZoo || {};

  DelhiZoo.indexPage = {
    init: function () {
      DelhiZoo.indexPage.allFormValidation();
      DelhiZoo.indexPage.handleRegOTPGeneration();
      DelhiZoo.indexPage.handleUserSignin();
      DelhiZoo.indexPage.handleOtpFieldFocus();
      DelhiZoo.indexPage.handleUserRegistration();
    },

    vars: {},

    handleOtpFieldFocus: function () {
      $(".otp_field .partitioned").on("keyup", function () {
        if (this.value.length === this.maxLength) {
          $(this).next(".partitioned").focus();
        }
      });
    },

    handleRegOTPGeneration: function () {
      $(".js-user-sign-form button").on("click", function (e) {
        e.preventDefault();
        var form = $(".js-user-sign-form");
        $(".js-invalid-captcha-message").addClass("dn");

        if (form.valid()) {
          $("#loading-overlay").show();

          $.ajax({
            url: form.attr("action"),
            type: "POST",
            data: form.serialize(),
            success: function (response) {
              $("#loading-overlay").hide();
              console.log(response);

              if (response.status === "otp_sent") {
                $(".js-user-sign-form-div").addClass("dn");
                $(".js-send-otp-form-div").removeClass("dn");
                $("<input>", {
                  name: "hiddenMobile",
                  id: "hiddenRegMob",
                  type: "hidden",
                  value: response.mobile_number,
                }).appendTo(".js-send-otp-form");

              } else if (response.status === "no_user_found") {
                $(".js-user-sign-form-div").addClass("dn");
                $(".js-new-user-registration-div").removeClass("dn");
                $("<input>", {
                  name: "user[mobile_number]",
                  id: "mobile_number",
                  type: "hidden",
                  value: response.mobile_number,
                }).appendTo(".js-new-user-registration");

              } else if (response.status === "invalid_captcha") {
                $(".js-captcha-refresh-button a").click();
                $(".js-invalid-captcha-message").removeClass("dn");
              }
            },
            error: function (response) {
              console.error(response);
              alert("Having trouble signing in, Please try after some time.");
            },
          });
        }
      });
    },

    handleUserSignin: function () {
      $(".js-send-otp-form button").on("click", function (e) {
        e.preventDefault();
        $("#loading-overlay").show();

        var enteredOtp = "";
        var mobileNumber = $("#hiddenRegMob").val();
        var form = $(".js-send-otp-form");

        $(".otp_field > input").each(function () {
          enteredOtp += $(this).val();
        });

        $.ajax({
          url: form.attr("action"),
          type: "POST",
          data: {
            user: {
              mobile_number: mobileNumber,
              entered_otp: enteredOtp,
            },
          },
          success: function (response) {
            $("#loading-overlay").hide();
            console.log(response)
            console.log(response.status === "sign_in")
            if (response.status === "sign_in") {
              window.location.href = response.url;
            } else if (response.status === "invalid_otp") {
              alert("Invalid OTP");
            }
          },
          error: function (response) {
            console.error(response);
          },
        });
      });
    },

    handleUserRegistration: function () {
      $(".js-new-user-registration button").on("click", function (e) {
        e.preventDefault();
        var form = $(".js-new-user-registration");

        if (form.valid()) {
          $("#loading-overlay").show();

          $.ajax({
            url: form.attr("action"),
            type: "POST",
            data: form.serialize(),
            success: function (response) {
              $("#loading-overlay").hide();

              if (response.status === "user_created") {
                $(".js-new-user-registration-div").addClass("dn");
                $(".js-send-otp-form-div").removeClass("dn");
                $("<input>", {
                  name: "hiddenMobile",
                  id: "hiddenRegMob",
                  type: "hidden",
                  value: response.mobile_number,
                }).appendTo(".js-send-otp-form");

              } else if (response.status === "error") {
                alert(response.message);
              }
            },
            error: function (response) {
              console.error(response);
            },
          });
        }
      });
    },

    allFormValidation: function () {
      $(".js-user-sign-form").validate({
        errorClass: "error_message",
        rules: {
          "user[mobile_number]": {
            required: true,
            number: true,
            minlength: 10,
            maxlength: 10,
          },
        },
        messages: {
          "user[mobile_number]": {
            required: "Please enter 10 digit mobile number",
            number: "Please enter a numeric value",
            minlength: "Please enter 10 digit mobile number",
            maxlength: "Please enter 10 digit mobile number",
          },
        },
      });

      $(".js-new-user-registration").validate({
        errorClass: "error_message",
        rules: {
          "user[first_name]": {
            required: true,
            minlength: 3,
            maxlength: 15,
          },
          "user[age]": {
            required: true,
            number: true,
          },
          "user[email]": {
            email: true,
          },
          "user[gender]": {
            required: true,
          },
        },
        messages: {
          "user[first_name]": {
            required: "Please enter your first name",
            minlength: "First name should be at least 3 characters",
            maxlength: "First name should not be greater than 20 characters",
          },
          "user[age]": {
            required: "Please enter your age",
            number: "Please enter a numeric value",
          },
          "user[email]": {
            email: "Please enter a valid email",
          },
          "user[gender]": {
            required: "Please enter your gender",
          },
        },
      });
    },
  };

  window.DelhiZoo = DelhiZoo;

  $(document).ready(function () {
    DelhiZoo.indexPage.init();
  });
})(jQuery, window);
